import { render, staticRenderFns } from "./CreateEditPopupBanner.vue?vue&type=template&id=5c48ff78&scoped=true"
import script from "./CreateEditPopupBanner.vue?vue&type=script&lang=js"
export * from "./CreateEditPopupBanner.vue?vue&type=script&lang=js"
import style0 from "./CreateEditPopupBanner.vue?vue&type=style&index=0&id=5c48ff78&prod&scoped=true&lang=css"
import style1 from "./CreateEditPopupBanner.vue?vue&type=style&index=1&id=5c48ff78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c48ff78",
  null
  
)

export default component.exports